import tmp_logo from 'assets/images/tmp-logo.png';
import xceedanceHeroImage from 'assets/images/xceedance_hero.avif';
import heroImage from 'assets/images/hero-image.avif';
import Logo from 'components/Logo';
import { isAdmiral, isHorwich, isThompsons, isXceedance } from 'utils/helpers';

export const displayLogo = ({ companyLogo = '' }) => {
  if (isXceedance()) return null;

  if (isThompsons()) {
    return (
      <>
        <Logo
          src={tmp_logo}
          className="margin-30-bottom"
          width={300}
          height={70}
          fullLogo
        />
        <p className="tmp-welcome-text">Welcome to the Thompsons Client Hub</p>
      </>
    );
  }

  return (
    <Logo
      src={companyLogo}
      className="margin-30-bottom max-width-60"
      width={175}
      height={20}
      fullLogo
    />
  );
};

export const setLoginStyles = ({ window }) => {
  if (isThompsons()) return 'tmp-login';
  else if ((isHorwich() || isAdmiral()) && window?.innerHeight <= 800)
    return 'horwich-login-left';
  else if (isXceedance()) return 'xceedance-login';
  else return 'login-left';
};

export const setHeroImage = () => {
  if (isXceedance()) return xceedanceHeroImage;
  return heroImage;
};

export const getPhoneLast = (str) => {
  if (typeof str !== 'string') return '';
  return str.slice(-4);
};

export const getUserPhone = (data) => {
  if (!data) return '';

  if (data?.phone) return data.phone;
  else if (data?.phones) {
    if (data.phones.homePhone) return data.phones.homePhone;
    else if (data.phones.mobilePhone) return data.phones.mobilePhone;
    else if (data.phones.workPhone) return data.phones.workPhone;
  } else return '';
};

export const getUserEmail = (data) => {
  if (!data) return;

  if (data?.email) return data.email;
  else return '';
};
